// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3ZYci","text":"SelectPayment_text__28CAQ","title":"SelectPayment_title__2bHPD","btn":"SelectPayment_btn__dP5vF"};